import React from 'react';
import Anchor from "../objects/Anchor";
import EventsCard from "./cards/EventsCard";
import DocumentsCard from "./cards/DocumentsCard";
import InteractiveWebinars from "./cards/InteractiveWebinars";
import InteractiveWebinarsImage from "./cards/InteractiveWebinarsImage";
import BlogsCard from './cards/BlogsCard'
import CoursesCard from './cards/CoursesCard'
import PodcastsCard from './cards/PodcastsCard'
import SeriesPodcastsCard from './cards/SeriesPodcastsCard'
import VideoModal from "./modals/VideoModal";
import { PrismicDocumentHelper } from "../../../helpers/prismicHelpers/PrismicHelpers";
// Card helpers
import {
    eventsListHelper,
    DocumentListHelper,
    BlogsListHelper,
    CoursesListHelper,
    PodcastsListHelper,
    WebinarsListHelper,
    PodcastsSeriesListHelper
} from "../../../helpers/prismicHelpers/prismic-custom-helpers/HomepageCardHelpers";
import { isDateTodayOrLater } from '../../../helpers/dateHelpers';

class CardWrapper extends React.Component {

    state = {
        cardData: '',
        isModalOpen: false,
        webinarUrl: '',
        podcastEpisodes: ''
    };

    openModal = (url, webinar) => {
        this.setState({
            webinarUrl: url,
            isModalOpen: true,
            webinar: webinar
        })
    };

    closeModal = () => {
        this.setState({
            isModalOpen: false
        })
    };

    getCards = () => {

        let cardsIds = [];
        const podcastIds = []


        // switch statement to check the card type passed down through props and for each individual card type do a request to prismic with an array of the 4 IDs to get the data we need for each card which is then passed into our card helper to give us it in the correct structure, this data object is then set in state.

        switch (this.props.type) {
            case 'events':
                PrismicDocumentHelper('document.type', 'single-event', false, 'at').then((data) => eventsListHelper(data)).then((data) => this.setState({ cardData: data }));
                break;
            case 'documents':
                this.props.cards.map(document => {
                    document.document_id.id && cardsIds.push(document.document_id.id);
                });
                PrismicDocumentHelper('document.id', cardsIds, false, 'in').then((data) => DocumentListHelper(data)).then((data) => this.setState({ cardData: data }));
                break;
            case 'blogs':
                this.props.cards.map(blog => {
                    blog.blog_id.id && cardsIds.push(blog.blog_id.id);
                });
                PrismicDocumentHelper('document.id', cardsIds, false, 'in').then((data) => BlogsListHelper(data)).then((data) => this.setState({ cardData: data }));
                break;
            case 'courses':
                this.props.cards.map(course => {
                    course.course_id.id && cardsIds.push(course.course_id.id);
                });
                PrismicDocumentHelper('document.id', cardsIds, false, 'in').then((data) => CoursesListHelper(data)).then((data) => this.setState({ cardData: data }));
                break;
            case 'podcast':
                this.props.cards.map(podcast => {
                    podcast.podcast.id && cardsIds.push(podcast.podcast.id);
                });
                if (this.props.cards[0].podcast.type === 'series-podcast') {
                    PrismicDocumentHelper('document.id', cardsIds, false, 'in')
                        .then(data => PodcastsSeriesListHelper(data))
                        .then(data => {
                            this.setState({ cardData: data });
                            data.seriesList.map(series => {
                                podcastIds.push(series.episodes);
                                this.setState({
                                    podcastEpisodes: podcastIds,
                                });
                            });
                        });
                } else {
                    PrismicDocumentHelper('document.id', cardsIds, false, 'in')
                        .then(data => PodcastsListHelper(data))
                        .then(data =>
                            this.setState({ cardData: data, podcastEpisode: data })
                        );
                }
                break;
            case 'webinars':
                this.props.cards.map(webinar => {
                    webinar.webinar_id.id && cardsIds.push(webinar.webinar_id.id);
                });
                PrismicDocumentHelper('document.id', cardsIds, false, 'in').then((data) => WebinarsListHelper(data)).then((data) => this.setState({ cardData: data }));
                break;
            default:
                null
                break;
        }
    };

    async componentWillMount() {
        await this.getCards()
    }

    render() {

        const { cardWrapperHeading, cardWrapperCta, altStyle } = this.props;
        const alt = altStyle === true ? 'alternative' : '';

        // This switch statement also checks card type but for each card type it maps over the data object in state and returns the corresponding card type for each one with the data for that card passed down as props, this is set as the variable cardType which we call in the return below.

        let cardType;
        switch (this.props.type) {
            case 'events':
                // Filter events to only those that are in-date and flagged as In Touch Live events on Prismic. Then only display the first 4, sorted chronologically. 
                const futureLiveEvents = this.state.cardData.eventsList && this.state.cardData.eventsList.filter(event => isDateTodayOrLater(event.date) && event.live).sort((a,b) => new Date(a.date) - new Date(b.date)).slice(0,4);
                cardType = this.state.cardData && futureLiveEvents.map((card, i) => {
                    return <EventsCard eventsData={card} key={i} length={futureLiveEvents.length}
                        clever={true} />
                });
                break;
            case 'documents':
                cardType = this.state.cardData && this.state.cardData.documentList.map((card, i) => {
                    return <DocumentsCard documentsData={card} key={i} length={this.state.cardData.documentList.length} clever={i === 0 ? true : null} />
                });
                break;
            case 'blogs':
                cardType = this.state.cardData && this.state.cardData.blogsList.map((card, i) => {
                    return <BlogsCard blogsData={card} key={i} length={this.state.cardData.blogsList.length}
                        clever={i === 0 ? true : null} />
                });
                break;
            case 'courses':
                cardType = this.state.cardData && this.state.cardData.coursesList.map((card, i) => {
                    return <CoursesCard coursesData={card} key={i} length={this.state.cardData.coursesList.length} clever={i === 0 ? true : null} />
                });
                break;
            case 'podcast':
                const cardTypes = this.state.cardData.seriesList
                    ? this.state.cardData.seriesList
                    : this.state.cardData.podcastsList;
                cardType =
                    cardTypes &&
                    cardTypes.map((card, i) => {
                        if (card.type === 'series') {
                            return (
                                <SeriesPodcastsCard
                                    episodeData={this.state.podcastEpisodes[i]}
                                    podcastsData={card}
                                    key={i}
                                    clever={i === 0 ? true : null}
                                    name={card.title}
                                    desc={card.description}
                                    index={i}
                                    length={this.state.cardData.seriesList.length}
                                />
                            );
                        } else {
                            return (
                                <PodcastsCard
                                    episodeData={this.state.podcastEpisode}
                                    podcastsData={card}
                                    key={i}
                                    clever={i === 0 ? true : null}
                                    index={i}
                                    length={this.state.cardData.podcastsList.length}
                                />
                            );
                        }
                    });
                break;
            case 'webinars':
                cardType = this.state.cardData && this.state.cardData.webinarsList.map((card, i) => {
                    if (card.media === 'video') {
                        return <InteractiveWebinars webinarsData={card} key={i}
                            clever={i === 0 ? true : null} length={this.state.cardData.webinarsList && this.state.cardData.webinarsList.length} openModal={this.openModal} />
                    }
                    else {
                        return <InteractiveWebinarsImage webinarsData={card} key={i} length={this.state.cardData.webinarsList.length} clever={i === 0 ? true : null} openModal={this.openModal} />
                    }
                });
                break;
            default:
                break;
        }

        return (
            <div className="card-wrapper-whole">
                <div className={`container highlight-container ${alt}`} data-aos>
                    <div className="highlight-container-inner">
                        <div className="row">
                            <div className="col-12 card-head">
                                <h2 className="heading-two">{cardWrapperHeading}</h2>
                                <Anchor internal path={cardWrapperCta} anchorClass={'clickable'}>
                                    View more
                                </Anchor>
                            </div>
                            {cardType && cardType}
                        </div>
                    </div>
                </div>
                <VideoModal
                    data={this.state.webinar}
                    closeModal={this.closeModal}
                    modalState={this.state.isModalOpen}
                    videoUrl={this.state.webinarUrl}
                    showFoot={true}
                />
            </div>
        );
    };
}

export default CardWrapper;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/CardWrapper.js